import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'TagRadio',
  props: {
    options: null,
    value: null
  },
  emits: ['change'],
  setup(__props: any, { emit }) {

const props = __props as {
  options: {
    label: string;
    key: string | number;
  }[];
  value?: string |number;
};




function handleChange(key){    
    emit('change',key)
}

return { __sfc: true,props, emit, handleChange }
}

})